import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Alert from './Alert';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import ButtonGroup from './ButtonGroup';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import Info from 'react-icons/lib/fa/info-circle';
import ProfileElementField from './ProfileElementField';
import CustomFormGroup from './CustomFormGroup';
import { validator, fieldsToValidate, pageValid, executeValidations } from '../../validator';
import { generateProfileElementObject, changeState } from '../../utilities';

class Profile extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      guestWelcomeMessage: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','public','guest_welcome_message'),
      publicProfile: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','public','public_profile'),
      hobbies: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','hobbies'),
      householdFullyVaccinated: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'public', 'household_fully_vaccinated')
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  componentDidMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onHostProfileSubmit({
      public: {
        guest_welcome_message: this.state.guestWelcomeMessage.val,
        public_profile: this.state.publicProfile.val,
        household_fully_vaccinated: this.state.householdFullyVaccinated.val
      },
      lifestyle: {
        hobbies: this.state.hobbies.val
      }
    });
    
    if (!this.props.vaccinationMandatory && this.state.householdFullyVaccinated.val) {
      this.props.onUpdateAllVaccinationsStatus('vaccinated')
    }
  }

  render() {
    const thisPage = P.PROFILE_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>

        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.profile.title} icon={<Info />}/>
          <CustomFormGroup valid={this.state.guestWelcomeMessage.valid}>
            <ControlLabel>{formatMessage(defaultMessages.clientHostPagesProfileLabelsGuestWelcomeMessage)}</ControlLabel>
            <FormControl
              id='guestWelcomeMessage'
              componentClass="textarea"
              style={{width:'100%'}}
              placeholder=""
              defaultValue={this.state.guestWelcomeMessage.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <Alert alert={content.pages.profile.info_01} />

          <CustomFormGroup valid={this.state.publicProfile.valid}>
            <ControlLabel>{formatMessage(defaultMessages.clientHostPagesProfileLabelsPublicProfile)}</ControlLabel>
            <FormControl
              id='publicProfile'
              componentClass="textarea"
              style={{width:'100%'}}
              placeholder=""
              defaultValue={this.state.publicProfile.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <ProfileElementField
            childComponent={
            <CustomFormGroup valid={this.state.hobbies.valid}>
                <ControlLabel>{formatMessage(defaultMessages.clientHostPagesProfileLabelsHobbies)}</ControlLabel>
                <FormControl
                  id='hobbies'
                  type="text"
                  style={{width: '100%'}}
                  componentClass="textarea"
                  placeholder={formatMessage(defaultMessages.clientHostPagesProfilePlaceholdersHobbies)}
                  defaultValue={this.state.hobbies.val}
                  onChange={e => this.changeState(e.target.id, e.target.value)} />
              </CustomFormGroup>
            }
            elementName='hobbies' />

          <Alert alert={content.pages.profile.info_02} />

          {!this.props.vaccinationMandatory && (
            <>
              <ProfileElementField
                childComponent={
                  <CheckboxOrRadioGroup
                    title={formatMessage(defaultMessages.clientHostPagesProfileLabelsHouseholdFullyVaccinated)}
                    setName={'householdFullyVaccinated'}
                    type={'radio'}
                    checkBoxStyle={'radio-inline'}
                    controlFunc={e => this.changeState('householdFullyVaccinated', e.target.value == 'true')}
                    options={[
                      [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                      [formatMessage(defaultMessages.clientCommonNegative), 'false']
                    ]}
                    valid={this.state.householdFullyVaccinated.valid}
                    selectedOptions={[String(this.state.householdFullyVaccinated.val)]} />
                }
                elementName={'household_fully_vaccinated'}
              />
              { this.props.activeProfileElements.includes('householdFullyVaccinated') && <Alert alert={content.pages.profile.info_03} /> }
            </>
          )}

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />

        </form>
      </div>
    );
  }
}

Profile.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(Profile);
